<template>
  <div class='pt-4 mr-5'>
    <div class='unrouted-box text-center'>
      <div class='subtitle-1 text-uppercase'>Un-Routed Projects</div>
      <div class='caption'>{{ unrouted.length + ' projects'}}</div>
      <project-list
        :isLoading='isLoading'
        :items='unrouted'
        :areProjectsSelected='false'
        :search='search'
        :noDataText='isPageLoading ? "Loading Projects..." : "No unrouted projects found"'
        @clicked='clicked'
        @openQuickView='openQuickView'
        @getLatLng='getLatLng'
      ></project-list>
    </div>
  </div>
</template>

<script>
// import _ from 'lodash'
import ProjectList from './ProjectList'

export default {
  name: 'unrouted',
  props: {
    unrouted: {
      required: true
    },
    isLoading: {
      required: true
    },
    isPageLoading: {
      required: false,
      type: Boolean,
      default: false
    },
    filterLawnCare: {
      required: false,
      type: Boolean,
      default: false,
    }
  },
  data: () => ({
    showSearch: false,
    search: '',
    headers: [
      { text: '', value: 'project' }
    ],
 
  }),
  computed: {

  },
  methods: {
    clicked (proj) {
      // let tmp = this.unrouted.find(p => p.pk === proj.pk)
      if (proj.is_selected === true) {
        this.$emit('deselect', proj)
        // tmp.is_selected = false
      } else {
        this.$emit('select', proj)
        // if (!this.filterLawnCare) {
        //   tmp.is_selected = true
        // }
      }
    },
    openQuickView (proj) {
      this.$emit('openQuickView', proj)
    },
    getLatLng (proj) {
      this.$emit('getLatLng', proj)
    }
  },
  components: {
    'project-list': ProjectList
  }
}
</script>

<style>

.unrouted-box {
  width: 220px !important;
  display: inline-block;
  border: 1px solid rgba(0, 0, 0, 0.12);
}

</style>